import React from 'react';

const DashboardPage = () => <h1>Dashboard Page</h1>;

export default DashboardPage;
